/**
 * A random icon of a Khan Academy topic.
 *
 * The icons are from Physics units but, for the purpose of prototyping, can
 * be used anywhere that needs a circular topic icon.
 */
// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import {randomTopicIconUrl} from '../core/Utilities';


const CircularTopicIcon = () => {
    return <img
        alt=""
        src={randomTopicIconUrl()}
        className={css(styles.circularTopicIcon)}
    />;
}


const styles = createExpandableMediaQueryStylesheet({
    circularTopicIcon: {
        display: "inline-block",
        width: CoreMetrics.IconSize.XXLarge(),
        height: CoreMetrics.IconSize.XXLarge(),
        borderRadius: "50%",
        backgroundColor: CoreMetrics.Color.Debug,
        marginRight: CoreMetrics.ElementPadding.XLarge(),
    },
});


export default CircularTopicIcon;



// WEBPACK FOOTER //
// ./src/modules/CircularTopicIcon.jsx